/**
 * @prettier
 * @flow
 */
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

export function Loading() {
    const classes = useStyles();
    return (
        <Grid container direction='row' justify='center' alignItems='center' className={classes.container}>
            <CircularProgress size={120} />
        </Grid>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
    },
}));
